import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { Provider, CreateProvider, UpdateProvider } from '@magnetar/admin-api-interfaces'

export const providerService = {
  createProvider: async (data: CreateProvider, token: string) => {
    try {
      const response = await apiClient.post<{ success: boolean; data: Provider }>(
        '/api/providers',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  updateProvider: async (providerId: number, data: UpdateProvider, token: string) => {
    try {
      const response = await apiClient.put<{ success: boolean; data: Provider }>(
        `/api/providers/${providerId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  deleteProvider: async (providerId: number, token: string) => {
    try {
      const response = await apiClient.delete<{ success: boolean }>(
        `/api/providers/${providerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  // Clinic assignment
  assignClinic: async (providerId: number, clinicId: number, token: string) => {
    try {
      const response = await apiClient.post<{ success: boolean }>(
        `/api/providers/${providerId}/clinics/${clinicId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  removeClinic: async (providerId: number, clinicId: number, token: string) => {
    try {
      const response = await apiClient.delete<{ success: boolean }>(
        `/api/providers/${providerId}/clinics/${clinicId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  // Supplier assignment
  assignSupplier: async (providerId: number, supplierId: number, token: string) => {
    try {
      const response = await apiClient.post<{ success: boolean }>(
        `/api/providers/${providerId}/suppliers/${supplierId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  removeSupplier: async (providerId: number, supplierId: number, token: string) => {
    try {
      const response = await apiClient.delete<{ success: boolean }>(
        `/api/providers/${providerId}/suppliers/${supplierId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },
}
